import {initialState, MessagesAndLettersState} from "@/store/modules/messagesAndLetters/index";
import {MutationTree} from 'vuex'


export const mutations: MutationTree<MessagesAndLettersState> = {


    resetState: (state) => {
        state = Object.assign(state, initialState())
    }

}